import React from 'react'
import DatePicker from 'react-datepicker'
import {useTranslation} from 'react-i18next'
import {InputGroup, Form} from 'react-bootstrap'
import Recurring from '../CustomComponents/AuditRecurring/CustomRecurringPage'
import CustomDateInput from '../AuditDateInput'
import Select from 'react-select'
import './AuditDetails.styles.scss'
import {withTranslation} from 'react-i18next'
import {AuditDetailsContext} from '../../../../context/Modal/AuditDetails'
import {AuditModalBarContext} from '../../../../context/AuditModalBar'
import {AuditPaneContext} from '../../../../context/AuditPane'

function AuditDetailsForm({error, setError}) {
  const {t} = useTranslation()
  const {
    name,
    method,
    start_date,
    due_date,
    allow_scanning_after_due_date,
    due_soon_days,
    gps_location,
    asset_details,
    status,
    signature,

    setName,
    setMethod,
    setStartDate,
    setDueDate,
    setAllowScanningAfterDurDate,
    setDueSoonDays,
    setGpsDetails,
    setAssetDetails,
    setSignature,
  } = React.useContext(AuditDetailsContext)
  const paneState = React.useContext(AuditPaneContext)
  const modalBar = React.useContext(AuditModalBarContext)
  let disabled = status === 'incomplete' && paneState.modalType === 'edit' ? true : false

  let nameError, methodError, startDateError, dueDateError, dueSoonDaysError
  let optionItems = [
    {label: 'Barcode Scan', value: 'barcode_scan'},
    {label: 'Manual Enter Id', value: 'manually_enter_id'},
    {label: 'Prompt Each Time', value: 'prompt_each_time'},
  ]

  if (modalBar.errors.length > 0) {
    modalBar.errors.map(err => {
      switch (err.error_field) {
        case 'name':
          nameError = err
          break
        case 'method':
          methodError = err
          break
        case 'start_date':
          startDateError = err
          break
        case 'due_date':
          dueDateError = err
          break
        case 'due_soon_days':
          dueSoonDaysError = err
          break
        default:
          break
      }
      return true
    })
  }

  return (
    <form className="audit-forms form-data">
      <div className="audit-width row">
        <div className="col-12">
          <label
            className={
              nameError
                ? 'required width-100-persent required-circle'
                : 'required width-100-persent'
            }
          >
            {paneState.modalFor === 'Audit' ? 'Audit Name' : 'Template Name'}
          </label>
          <input
            className="form-control"
            type="text"
            placeholder="Name"
            onChange={e => {
              setError('')
              setName(e.target.value)
              modalBar.handleNameLoading()
            }}
            value={name}
            defaultValue={name}
            disabled={disabled}
            required
          />
          {error && error.includes('/') ? (
            <div className="text-danger mb-8">{error}</div>
          ) : nameError ? (
            <div className="text-danger mb-8">{nameError.error_message}</div>
          ) : error ? (
            <div className="text-danger mb-8">{error}</div>
          ) : null}
        </div>
        <div
          className={
            status === 'incomplete' && disabled ? 'col-12 mt-15 not-allowed' : 'col-12 mt-15'
          }
        >
          <label
            className={
              methodError
                ? 'required width-100-persent required-circle'
                : 'required width-100-persent'
            }
          >
            Audit Method
          </label>
          <Select
            className={disabled ? 'not-allowed basic-single' : 'basic-single'}
            classNamePrefix="select"
            isSearchable={true}
            name="color"
            placeholder="Select"
            options={optionItems}
            onChange={e => setMethod(e.value)}
            value={optionItems.filter(({value}) => value === method)}
            defaultValue={optionItems.filter(({value}) => value === method)}
          />
          {methodError && <div className="text-danger">{methodError.error_message}</div>}
        </div>
        <div className="row col-12 padding-right-0 datepicker_tab_1">
          <div
            className={
              status === 'incomplete' && disabled
                ? 'col-6 padding-right-0 not-allowed'
                : 'col-6 padding-right-0'
            }
          >
            <label
              className={
                startDateError
                  ? 'required width-100-persent required-circle'
                  : 'required width-100-persent'
              }
              style={{marginTop: 20}}
            >
              Start Date
            </label>
            <InputGroup>
              <DatePicker
                placeholderText="mm/dd/yyyy"
                className="form-control"
                onChange={e => {
                  setStartDate(e)
                  modalBar.setEditWarning(true)
                }}
                minDate={new Date()}
                showYearDropdown
                yearDropdownItemNumber={5}
                dateFormatCalendar="MMMM"
                scrollableYearDropdown
                selectsStart
                customInput={<CustomDateInput id="start_date" />}
                selected={start_date ? new Date(start_date) : ''}
                startDate={start_date ? new Date(start_date) : ''}
                endDate={due_date ? new Date(due_date) : ''}
                disabled={disabled}
                name="start_date"
              />
            </InputGroup>
            {startDateError && (
              <div className="text-danger mb-8">{startDateError.error_message}</div>
            )}
          </div>
          <div className="col-6 padding-right-0 due_date">
            <label style={{marginTop: 20}}>Due Date</label>
            <InputGroup>
              <DatePicker
                placeholderText="mm/dd/yyyy"
                className="form-control"
                onChange={e => setDueDate(e)}
                minDate={new Date(start_date) > new Date() ? new Date(start_date) : new Date()}
                showYearDropdown
                yearDropdownItemNumber={5}
                dateFormatCalendar="MMMM"
                scrollableYearDropdown
                selectsEnd
                customInput={<CustomDateInput id="due_date" />}
                selected={due_date ? new Date(due_date) : ''}
                startDate={start_date ? new Date(start_date) : ''}
                endDate={due_date ? new Date(due_date) : ''}
                name="due_date"
              />
            </InputGroup>
            {dueDateError ? (
              <div className="text-danger mb-8">{dueDateError.error_message}</div>
            ) : (
              <small>Optional</small>
            )}
          </div>
        </div>

        {due_date && (
          <>
            <div className="styled_checkbox col-12 mt-10">
              <div className="option_0">
                <Form.Check
                  id="allow_scanning"
                  className="css-checkbox lrg"
                  type="checkbox"
                  aria-label="option 0"
                  label="Allow Scanning after due date."
                  onChange={() => setAllowScanningAfterDurDate(!allow_scanning_after_due_date)}
                  checked={allow_scanning_after_due_date}
                  disabled={disabled}
                />
              </div>
            </div>
            <div className="col-12 mt-15">
              <label
                className={
                  dueSoonDaysError
                    ? 'width-100-persent required-circle font_color'
                    : 'width-100-persent font_color'
                }
              >
                Due Soon Notification
              </label>
              <div className="col-12 row">
                <input
                  className="form-control col-2"
                  style={{padding: '0 4px', textAlign: 'center'}}
                  type="number"
                  min={0}
                  max={365}
                  onChange={e => setDueSoonDays(e.target.value)}
                  value={due_soon_days}
                  defaultValue={due_soon_days}
                  disabled={disabled}
                />
                <span className="col-10 font_color" style={{paddingTop: '5px'}}>
                  {t('audit.form-create-audit.days-before-due-date')}
                </span>
              </div>
              {dueSoonDaysError && (
                <div className="text-danger mb-8">{dueSoonDaysError.error_message}</div>
              )}
            </div>
          </>
        )}
        {paneState.modalType === 'edit' && paneState.modalFor === 'Audit' ? null : (
          <div className="col-12">
            <Recurring />
          </div>
        )}
        <div className="styled_checkbox col-12 mt-15">
          <div className="option_1">
            <Form.Check
              id="record_gps"
              className="css-checkbox lrg"
              type="checkbox"
              aria-label="option 1"
              label="Record GPS Location"
              onChange={() => setGpsDetails(!gps_location)}
              checked={gps_location}
              disabled={disabled}
            />
          </div>
          <div className="option_2">
            <Form.Check
              id="show_asset"
              className="css-checkbox"
              type="checkbox"
              aria-label="option 2"
              label="Show Asset Details After Each Scan "
              onChange={() => setAssetDetails(!asset_details)}
              checked={asset_details}
              disabled={disabled}
            />
          </div>
          <div className="option_3">
            <Form.Check
              id="signature"
              className="css-checkbox"
              type="checkbox"
              aria-label="option 3"
              label="Signature to Close Audit"
              onChange={() => setSignature(!signature)}
              checked={signature}
              disabled={disabled}
            />
          </div>
        </div>
      </div>
    </form>
  )
}

export default withTranslation()(AuditDetailsForm)
